(() => {
  const root = document.querySelector('[data-loomforma-search-page]');
  if (!root) return;

  const input = root.querySelector('[data-loomforma-search-input]');
  const rows = Array.from(root.querySelectorAll('[data-index-item]'));
  const emptyState = root.querySelector('[data-empty-state]');
  const visibleCount = root.querySelector('[data-visible-count]');

  if (!input || rows.length === 0) return;

  const formatCount = (count) => String(count).padStart(2, '0');

  const applyFilter = () => {
    const term = input.value.trim().toLowerCase();
    let shown = 0;

    rows.forEach((row) => {
      const haystack = row.getAttribute('data-search-text') || '';
      const matches = term === '' || haystack.includes(term);
      row.hidden = !matches;
      if (matches) shown += 1;
    });

    if (emptyState) {
      emptyState.hidden = shown > 0;
    }

    if (visibleCount) {
      visibleCount.textContent = formatCount(shown);
    }
  };

  input.addEventListener('input', applyFilter);
  applyFilter();
})();
